import { render, staticRenderFns } from "./SignupAuthentication.vue?vue&type=template&id=025ab664&scoped=true"
import script from "./SignupAuthentication.vue?vue&type=script&lang=js"
export * from "./SignupAuthentication.vue?vue&type=script&lang=js"
import style0 from "./SignupAuthentication.vue?vue&type=style&index=0&id=025ab664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025ab664",
  null
  
)

export default component.exports